
import {Component} from './base';

interface Title {
  id: string;
  name: string;
}
interface Style {
  id: number;
  name: string;
  color: string;
  bgcolor: string;
}

export class CalendarFiltersComponent extends Component {
  private game: string;

  private searchText: string = '';
  private titles: Title[] = [];
  private selectedTitles: Title[] = [];

  public static shouldLoad() {
    return $('.calendar-filter').length > 0;
  }

  public register() {
    this.app.eventManager.registerEvent({
      code: 'calendar-filters.change'
    });
  }

  public load() {
    // Gather facts.
    this.game = $('#hidden-game-short').val() as string;

    // Init filters
    this.initFilters();

    // Init popover
    this.initPopovers();

    // Listen for filter changes.
    const self = this;
    $('body').on('change', 'input.filter-inputs', function() {
      self.submitFilter($(this));
    });

    // Listen for search changes.
    $('input#search').keypress(function (e) {
      if (e.which === 13) {
        self.submitSearch($(this));
      }
    });
    $('#search-submit').click(function() {
      self.submitSearch($('input#search'));
    })
  }

  public initFilters() {
    $.getJSON(`/calendar/${this.game}/filters`).then((res) => {
      if (res.titles) {
        this.titles = res.titles;
      }
    });
  }

  public initPopovers() {
    const self = this;
    $('#title-filter-button').popover({
      content: function () {
        const type = $(this).data('type');
        return self.getPopoverContent(type);
      },
      trigger: 'click',
      animation: true,
      placement: 'bottom',
      html: true,
    });
  }

  public getPopoverContent(type: string) {
    const html = $($('#'+type+'-filter-content').html());

    let optionList = this.titles;
    let selectedList = this.selectedTitles;

    let listElement = html.find('ul');
    listElement.empty();

    for (let option of optionList) {
      let selected = selectedList.indexOf(option) !== -1 ? 'checked="checked"' : '';
      let optionHtml = `
                        <li>
                            <label>
                                <input type="checkbox" name="title-filter" data-type="${type}" class="filter-inputs" ${selected} value="${option.id}" />
                                &nbsp;${option.name}
                            </label>
                        </li>
`;
      listElement.append(optionHtml);
    }

    return html;
  }

  /**
   * Submit search phrase.
   * @param {JQuery<HTMLElement>} element
   */
  private submitSearch(element: JQuery<HTMLElement>) {
    const value = element.val() as string;

    if (value.length > 0) {
      this.searchText = value;
    } else {
      this.searchText = '';
    }

    // Call action.
    this.app.eventManager.fire('calendar-filters.change', {
      titles: this.selectedTitles.map((title) => title.id),
      search: this.searchText
    });
  }

  /**
   * Change action for element and value.
   */
  private submitFilter(element: JQuery<HTMLElement>) {
    const type = element.data('type') as string;
    const identifier = element.val() as string;

    let selected: Title|null = null;
    for (const title of this.titles) {
      if (title.id === identifier) {
        selected = title;
      }
    }
    if (! selected) {
      return;
    }

    if (element.is(':checked')) {
      this.selectedTitles.push(selected);
    } else {
      let index = this.selectedTitles.indexOf(selected);
      if (index > -1) {
        this.selectedTitles.splice(index, 1);
      }
      this.selectedTitles.unshift()
    }

    // Update counts.
    $(`#${type}-filter-button`).find('span.badge').text(this.selectedTitles.length);

    // Call the event.
    this.app.eventManager.fire('calendar-filters.change', {
      titles: this.selectedTitles.map((title) => title.id),
      search: this.searchText
    });
  }
}



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/Resources/assets/js/components/calendar-filters.ts